<template>
  <div class="serveDetail">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>

    <!-- 面包屑导航 -->
    <div style="width: 1200px; margin: 0 auto">
      <div class="crumbs">
        <span>当前位置：</span>
        <span @click="toHome">首页 ></span>
        <span @click="toActivity">活动 ></span>
        <span @click="toActivityList">{{ catalogueName }} ></span>
        <span>活动详情</span>
      </div>
    </div>

    <div class="head">
      <img :src="data.coverImg" alt="" />
      <div class="text">
        <div class="text-b" id="text-bss">{{ data.activityName }}</div>
        <div class="text-s"
          v-for="(item, index) in data.customModels.filter((citem, cindex) => (cindex != data.customModels.length - 1 && cindex != data.customModels.length - 2))"
          :key="index">
          <span v-html="item.key"></span><span>{{ item.value }}</span>
        </div>
        <div class="text-s" v-if="data.customModels.length" style="float: left">
          <span>{{ data.customModels[data.customModels.length - 2].key }}</span><span style="color: #3476c1">{{
            data.customModels[data.customModels.length - 2].value
            }}</span>
        </div>
        <div class="text-s" v-if="data.customModels.length" style="float: left; margin-left: 50px">
          <span>{{ data.customModels[data.customModels.length - 1].key }}</span><span style="color: #3476c1">{{
            data.customModels[data.customModels.length - 1].value
            }}</span>
        </div>
        <div :style="{ clear: 'both', height: divheihgt + 'px' }"></div>

        <div style="position: absolute; bottom: -40px" v-if="data.coverImg">
          <button class="zixunbtn"><span class="zixunspan"></span>咨询</button>
          <button key="hasmoney" v-if="data.tabelData" class="ljbmbtn" @click="payFunModel">{{ data.tabelData[0].bz
            }}</button>
          <button v-else class="ljbmbtn">立即报名</button>
        </div>
      </div>
    </div>
    <div class="serveDetails">
      <div class="blueLine"></div>
      <div class="serveDetailsCH">活动详情</div>
      <div class="serveDetailsEN">Activity details</div>
      <div class="article" ref="remark" v-html="data.remark || data.baseRemark">
      </div>
      <div style="clear: both"></div>
      <div class="ffms" v-if="data.tabelData" style="margin-top: 20px;">
        <div class="blueLine"></div>
        <div class="serveDetailsCH">有偿服务付费公式</div>
        <div class="serveDetailsEN">Pricing Formula</div>
        <div style="clear: both"></div>
        <el-table header-row-class-name="yc_header" :data="data.tabelData" border style="width: 100%;margin-top: 20px;">
          <el-table-column prop="mc" label="项目名称" width="220" align="center" />
          <el-table-column prop="dw" label="计费单位" width="220" align="center" />
          <el-table-column prop="bz" label="收费标准" width="220" align="center" />
          <el-table-column prop="nr" label="服务内容" align="center" />
        </el-table>
      </div>
    </div>
    <el-dialog class="activityDetail_dialog" title="订单信息" @closed="modelClosed" :visible.sync="dialogVisible"
      width="640px">
      <div class="ad_content">
        <div class="ad_header">
          <div class="ad_h_item">
            <div class="ad_h_l">商品名称：</div>
            <div class="ad_h_r">{{ activeName }}</div>
          </div>
          <div class="ad_h_item">
            <div class="ad_h_l">订单编号：</div>
            <div class="ad_h_r">{{ payNo }}</div>
          </div>
          <div class="ad_h_item">
            <div class="ad_h_l">应付金额：</div>
            <div class="ad_h_r"><span>{{ payMoney }}</span></div>
          </div>
        </div>
        <div class="ad_pay">
          <div class="pay_way" v-if="!showPay">
            <div class="pay_way_tips">
              请选择支付方式：
            </div>
            <div class="pay_way_btns">
              <div class="pay_way_btn" @click="showPayFun(1)">
                <img src="https://file.jycyfww.com/wangchuang/qc/prod/static/img/80ec726e20ee41fc94bd6433c40b4a4a.png"
                  alt=""><img
                  src="https://file.jycyfww.com/wangchuang/qc/prod/static/img/6352f4eded7e4bfd9233ec56733243d3.png"
                  class="hover" alt="">
                微信支付
              </div>
              <div class="pay_way_btn" @click="showPayFun(2)">
                <img src="https://file.jycyfww.com/wangchuang/qc/prod/static/img/45018c28151448a78b9139ef08c97020.png"
                  alt=""><img
                  src="https://file.jycyfww.com/wangchuang/qc/prod/static/img/e041631b962c4fa1ae20f028ab1dd55c.png"
                  class="hover" alt="">
                银行转款
              </div>
            </div>
          </div>
          <div class="pay_in" v-else>
            <div class="pay_in_tips">
              收款方：启创未来（北京）科技有限公司
            </div>
            <div class="pay_code" v-if="payType == 1">
              <img class="code_img"
                src="https://file.jycyfww.com/other/static/data/c6ff8e1dae294f3386e6951182264bee.png" alt="">
              <div class="pay_code_tips">请使用微信扫码支付</div>
            </div>
            <div class="pay_other" v-if="payType == 2">
              <div class="pay_other_content">
                <p class="big">对公汇款账户信息：</p>
                <p><span>公司名称：</span>启创未来(北京)科技有限公司</p>
                <p><span>开户银行：</span>中国民生银行股份有限公司北京上地支行</p>
                <p><span>银行账号：</span>617568885</p>
                <p class="color">* 汇款时请务必备注订单号，以便系统核销开通。</p>
                <p class="color">* 联系电话：010-82696524</p>
              </div>
              <div class="pay_other_tips">汇款完成后预计 1-3 个工作日更新状态</div>
            </div>
            <div class="pay_btn" @click="showPay = false">返回修改支付方式</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import helloworld from '@/components/helloworld.vue' //引入组件
import navigation from "@/components/common/navigation";
import { aiList } from "@/utils/AiActivity";
export default {
  name: "activityDetail",
  components: {
    navigation,
  },
  data() {
    return {
      dialogVisible: false,
      data: { customModels: [] },
      catalogueName: this.$route.query.catalogueName,
      divheihgt: 30,
      payType: 1, // 1:微信支付 2:转账
      showPay: false,
      payNo: '',
      payMoney: '100.00',
      activeName: '“创业丰台2022”创业创新大赛报名费',
    };
  },
  methods: {
    // 付款弹窗关闭
    modelClosed() {
      this.showPay = false
    },
    // 付款弹窗
    payFunModel() {
      this.activeName = this.data.activityName
      this.payMoney = this.data.tabelData[0].bz
      this.payNo = `ORD${new Date().getTime()}`
      this.dialogVisible = true
    },
    // 修改支付方式
    showPayFun(type) {
      this.payType = type
      this.showPay = true
    },
    toHome() {
      sessionStorage.setItem("tabIndex", 1);
      this.$router.push("/");
    },
    toActivity() {
      this.$router.push("/activity");
    },
    toActivityList() {
      // this.$router.push('/activityList')
      let id = this.$route.query.catalogueId;
      this.$router.push({
        path: "/activityList",
        query: {
          id,
        },
      });
    },
    outoHeightFn() {
      setTimeout(() => {
        let dom = this.$refs.remark;
        const height = this.$refs.remark.offsetHeight;
        if (height < 300) {
          dom.style.height = "300px";
        }
      }, 300);
    },
  },
  created() {
    let catalogueId = this.$route.query.catalogueId;
    let activityId = this.$route.query.activityId;
    if (catalogueId == 9999) {
      let data = aiList.filter(i => i.activityId == activityId)
      if (data.length) {
        this.data = data[0]
      } else {
        this.$message({
          message: '暂无数据',
          type: "warning",
        });
      }
    } else {
      this.$axios
        .post("/v1/cloud/common/activity/details", {
          activityId,
        })
        .then(({ data }) => {
          if (data) {
            this.data = data;
            this.$nextTick(() => {
              console.log(document.getElementById("text-bss").clientHeight);
              if (document.getElementById("text-bss").clientHeight > 50) {
                this.divheihgt = 10
              }
            });
          }
        })
        .catch((error) => {
          this.$message({
            message: error.response.data.message,
            type: "warning",
          });
        });
    }

  },
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
    //内容详情高度样式适配
    // this.outoHeightFn();
  },
};
</script>

<style scoped lang="less">
.ffms_tips {
  margin-top: 30px;
  font-family: PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  line-height: 16px;
}

::v-deep .yc_header {
  th {
    height: 46px;
    line-height: 1;
    background: rgba(52, 118, 193, 0.05);
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 14px;
  }
}

.serveDetail {
  width: 100%;
  background-color: #f5f5f5;
  padding-bottom: 100px;

  .zixunspan {
    width: 18px;
    height: 14px;
    display: inline-block;
    background-image: url("../../static/server/zixunicon.png");
    background-size: 18px 14px;
    vertical-align: middle;
    margin-right: 9px;
  }

  button {
    width: 140px;
    height: 40px;
    border: 1px solid #3476c1;
    background-color: #fff;
    font-style: 16px;
    font-family: MicrosoftYaHei;
    outline: none;
    font-weight: 400;
    // margin-top: 15px;
    margin-right: 30px;
    color: #3476c1;
    border-radius: 3px;
    cursor: pointer;
  }

  button.ljbmbtn {
    background-color: #3476c1;
    color: #fff;
  }

  // position: relative;
  .crumbs {
    width: 510px;
    height: 12px;
    // position: absolute;
    // top: -60px;
    // left: 960px;
    float: left;
    margin-top: 20px;
    font-family: MicrosoftYaHei;

    span {
      float: left;
      font-style: 12px;
      cursor: pointer;
      margin-left: 5px;
      color: #666666;
    }

    span:nth-child(5) {
      color: #333333;
    }

    // span:nth-child(3){
    //     margin-left: 10px;
    // }
  }

  .head {
    width: 1200px;
    height: 340px;
    margin: 60px auto 0;
    padding: 20px;
    background-color: #fff;
    box-sizing: border-box;

    img {
      width: 470px;
      height: 300px;
      float: left;
    }

    .text {
      width: 660px;
      float: right;
      margin-left: 30px;
      padding-top: 7px;
      position: relative;

      .text-b {
        font-size: 24px;
        line-height: 29px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #333333;
        margin-bottom: 9px;
      }

      .text-s {
        span:first-of-type {
          font-size: 16px;
          color: #999999;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          line-height: 35px;
        }

        span:last-of-type {
          font-size: 16px;
          color: #333333;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          margin-left: 10px;
          line-height: 35px;
        }

        // >span{
        //     display: block;
        //     font-size: 18px;
        //     color: #999999;
        //     margin-top: 10px;
        //     span{
        //         color:#333333;
        //     }
        //     .people{
        //         margin-right: 50px;
        //     }
        //     .money{
        //         font-size: 24px;
        //         color: #FD6114;
        //     }
        // }
      }
    }
  }

  .serveDetails {
    // height: 1000px;
    height: auto;
    width: 1200px;
    margin: 20px auto 0;
    // margin-top: 50px;
    padding: 40px 25px;
    padding-top: 30px;
    background-color: #fff;

    .blueLine {
      width: 4px;
      height: 20px;
      background: rgba(15, 155, 241, 1);
      float: left;
      margin-top: 5px;
    }

    .serveDetailsCH {
      float: left;
      // width:78px;
      // height:19px;
      font-size: 20px;
      font-family: MicrosoftYaHei;
      font-weight: 500;
      color: #333333;
      margin-left: 10px;
    }

    .serveDetailsEN {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #999999;
      float: left;
      margin-left: 10px;
      margin-top: 7px;
    }

    .article {
      width: 100%;
      float: left;
      font-style: 16px;
      margin-top: 25px;
      font-family: MicrosoftYaHei;
      text-align: justify;
      padding-left: 10px;
    }
  }
}
</style>
<style lang="less">
.activityDetail_dialog {
  .el-dialog {
    border-radius: 3px;
    box-shadow: none;
  }

  .el-dialog__header {
    padding: 40px 0 30px 0;
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    text-align: center;

    .el-dialog__title {
      height: 20px;
      line-height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .el-dialog__headerbtn {
      width: 15px;
      height: 15px;
      background-image: url('https://file.jycyfww.com/wangchuang/qc/prod/static/img/e1611aa8bfda4caea2997d9d3d448c14.png');
      background-size: 15px 15px;
      background-repeat: no-repeat;
      background-position: center;

      i {
        display: none;
      }
    }
  }

  .el-dialog__body {
    padding: 0 30px 40px;
  }

  .ad_content {
    width: 100%;

    .ad_header {
      width: 100%;
      box-sizing: border-box;
      padding: 20px;
      background: #F9F9F9;
      border-radius: 3px 3px 3px 3px;

      .ad_h_item {
        height: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 14px;

        .ad_h_r {
          span {
            color: #D33535;
          }
        }

      }

      .ad_h_item+.ad_h_item {
        margin-top: 24px;
      }
    }

    .ad_pay {
      margin-top: 24px;
      border-top: 1px solid #EEEEEE;
      padding-top: 24px;

      .pay_way {
        .pay_way_tips {
          height: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          line-height: 14px;
        }

        .pay_way_btns {
          margin-top: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
          column-gap: 30px;

          .pay_way_btn {
            width: 150px;
            height: 40px;
            border-radius: 3px 3px 3px 3px;
            border: 1px solid #EEEEEE;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            column-gap: 5px;
            cursor: pointer;
            user-select: none;

            img {
              display: block;
              width: 20px;
              height: 20px;
            }

            .hover {
              display: none;
            }

            &:hover {
              background: #5FC0E4;
              border-color: #5FC0E4;
              color: #fff;

              img {
                display: none;
              }

              .hover {
                display: block;
              }
            }
          }
        }
      }

      .pay_in {
        .pay_in_tips {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          line-height: 14px;
          margin-left: 20px;
        }

        .pay_code {
          margin-top: 30px;

          .code_img {
            display: block;
            width: 100px;
            height: 100px;
            margin: 0 auto;
          }

          .pay_code_tips {
            margin-top: 10px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 14px;
            text-align: center;
          }
        }

        .pay_other {
          margin-top: 24px;
          width: 100%;
          padding: 0 20px;
          box-sizing: border-box;

          .pay_other_content {
            width: 100%;
            padding: 20px;
            box-sizing: border-box;
            background: rgba(211, 53, 53, 0.05);
            border-radius: 3px 3px 3px 3px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 21px;

            .big {
              color: #333333;
            }

            p {
              color: #666;

              span {
                color: #999;
              }
            }

            .color {
              color: #D33535;
              font-size: 12px;
            }
          }

          .pay_other_tips {
            text-indent: 20px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 12px;
            margin-top: 10px;
          }
        }

        .pay_btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 150px;
          height: 40px;
          border-radius: 3px 3px 3px 3px;
          border: 1px solid #3476C1;
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #3476C1;
          box-sizing: border-box;
          margin: 30px auto 0;
          cursor: pointer;
          user-select: none;
        }
      }
    }
  }
}
</style>